// extracted by mini-css-extract-plugin
export default {"controls":"HomePageHeaderComponent_controls__bCydV","yearSelect":"HomePageHeaderComponent_yearSelect__KiH0M"};